import { getStorage } from 'helpers'
import { constants } from 'helpers/constants'
import { useState } from 'react'

export const useServiceWorkerUpdate = () => {
    const storedState = getStorage(constants.SERVICE_WORKER_UPDATE_KEY)
    const [updateAvailable, setUpdateAvailable] = useState(!!storedState)

    const handleUpdate = () => {
        setUpdateAvailable(false)
        localStorage.removeItem(constants.SERVICE_WORKER_UPDATE_KEY)
        window.location.reload()
    }

    return {
        updateAvailable,
        handleUpdate
    }
}
